import React, { useEffect, useState } from "react";

import PageTitle from "components/PageTitle";
import Table from "components/TableComp";

import { Alert, Button, Card, Form, Modal, Toast } from "react-bootstrap";
import { ConfirmAlert } from "components";

import axios from "axios";

export interface Idica {
  id: number;
  nome: string;
}

interface IColunaTabela {
  row: any;
  deleteFn?: (rowId: number | string) => Promise<void>;
  toggleOpcao?: (id: string) => void;
  editFn?: (id: number, nome: string) => void;
}

const ColunaDescricao = ({ value }: any) => {
  return <span>{value}</span>;
};

function ColunaAction({
  row,
  deleteFn,
  toggleOpcao,
  editFn,
}: IColunaTabela) {
  const handleEdit = () => {
    editFn?.(row.original.id, row.original.nome);
  };

  return (
    <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
      <span
        className="action-icon"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          handleEdit();
        }}
        title="Editar"
      >
        <i className="mdi mdi-square-edit-outline"/>
      </span>

      {toggleOpcao && (
        <span
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            toggleOpcao(String(row.original.id));
          }}
          title="Gerenciar opções"
        >
          <i className="mdi mdi-format-list-checks"/>
        </span>
      )}

      <ConfirmAlert
        text={`Excluir o item "${row.original.dica}"?`}
        cb={() => deleteFn!(row.original.id)}
      >
        <span style={{ cursor: "pointer", margin : "2px" }} title="Excluir">
          <i className="mdi mdi-delete" />
        </span>
      </ConfirmAlert>
    </div>
  );
}
export const fetchDicas = async () => {
  return await axios.get("/ajuda-alvo")
}
export default function PreCadastoDicas() {
  const [loading, setLoading] = useState(false);

  const [reload, setReload] = useState<number>(0);

  const [dica, setdica] = useState<string>("");

  const [modalCreate, setModalCreate] = useState(false);

  const [modalEdit, setModalEdit] = useState(false);

  const [editingId, setEditingId] = useState<number | null>(null);

  const [editingdica, setEditingdica] = useState<string>("");

  const [tableData, setTableData] = useState<Idica[]>([]);

  const [toastMessage, setToastMessage] = useState<string>();

  const [toastType, setToastType] = useState<"success" | "error">("success");

  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const getDicas = async () => {
      try {
        setLoading(true);

        const response = await fetchDicas();
        setTableData(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    getDicas();
  }, [reload]);

  const deletedica = async (id: string | number) => {
    try {
      setLoading(true);

      await axios.delete(`/ajuda-alvo/${id}`);
      setToastMessage("Dica deletada com sucesso!");
      setToastType("success");
      setShowToast(true);
      setReload((prev) => prev + 1);
    } catch (error) {
      setToastMessage("Falha ao deletar dica");
      setToastType("error");
      setShowToast(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (id: number, nome: string) => {
    setEditingId(id);
    setEditingdica(nome);
    setModalEdit(true);
  };

  const editdica = async () => {
    try {
      if (!editingdica.trim()) return;

      setLoading(true);

      await axios.put(`/ajuda-alvo/${editingId}`, {
        nome: editingdica.trim(),
      });

      setEditingId(null);
      setEditingdica("");

      setModalEdit(false);

      setReload((prev) => prev + 1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createdica = async () => {
    try {
      if (!dica.trim()) return;

      setLoading(true);

      await axios.post("/ajuda-alvo", {
        nome: dica.trim(),
      });

      setToastMessage("dica criado com sucesso!");
      setToastType("success");
      setShowToast(true);
      setdica("");
      setModalCreate(false);
      setReload((prev) => prev + 1);
    } catch (error) {
      setToastMessage("Falha ao criar dica");
      setToastType("error");
      setShowToast(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Curriculo", path: "#" },
          {
            label: "Pré-cadastro de Dicas",
            path: "/dica",
            active: true,
          },
        ]}
        title="Pré-cadastro de Dicas"
      />

      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="header-title mb-0">Dicas</h4>

            <Button
              variant="primary"
              onClick={() => {
                setModalCreate(true);
              }}
            >
              <i className="mdi mdi-plus-circle me-1" />
              Criar item
            </Button>
          </div>

          <p className="text-muted small">
            Gerencie as Dicas disponíveis nos programas.
          </p>

          {loading ? (
            <p className="text-muted">Carregando...</p>
          ) : (
            <Table
              columns={[
                {
                  Header: "Dica",
                  accessor: "nome",
                  Cell: ColunaDescricao,
                  sort: false,
                },
                {
                  Header: "",
                  accessor: "id",
                  Cell: ({ row }: any) => {
                    return (
                      <ColunaAction
                        row={row}
                        deleteFn={deletedica}
                        editFn={openEditModal}
                      />
                    );
                  },
                  sort: false,
                },
              ]}
              data={tableData}
              tableClass="table-striped"
              pagination={false}
            />
          )}
        </Card.Body>
      </Card>

      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 1050,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2000}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </div>

      <Modal
        show={modalEdit}
        onHide={() => {
          setModalEdit(false);
          setEditingId(null);
          setEditingdica("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar dica</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Dica</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome da Dica"
                value={editingdica}
                onChange={(e) => setEditingdica(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalEdit(false);
              setEditingId(null);
              setEditingdica("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              editdica();
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalEdit}
        onHide={() => {
          setModalEdit(false);
          setEditingId(null);
          setEditingdica("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar dica</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>dica</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome da Dica"
                value={editingdica}
                onChange={(e) => setEditingdica(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalEdit(false);
              setEditingId(null);
              setEditingdica("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              editdica();
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalCreate}
        onHide={() => {
          setModalCreate(false);
          setdica("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Criar dica</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Dica</Form.Label>

              <Form.Control
                type="text"
                placeholder="Digite o nome da Dica"
                value={dica}
                onChange={(e) => setdica(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setModalCreate(false);
              setdica("");
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              createdica()}}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}